import { useMemo } from "react"
import { useAccountId } from "resources/account"
import PreferenceContext from "hooks/preferences"
import { AiTeammateProvider } from "connected-components/ai-teammate/context"
import { ThreadsProvider } from "connected-components/ai-teammate/context/threads"
import { MessagesProvider } from "connected-components/ai-teammate/context/messages"
import { AiTeammateAnalyticsProvider } from "connected-components/ai-teammate/analytics"
import ChatWorkspace from "./components/workspace"
import "./style.scss"

export default function AgentChat() {
  const accountId = useAccountId()
  // This page does not persist anything to user preferences (persistPreferences={false} below).
  // The provider stays mounted only so the now-disabled preference hooks have a context to read;
  // no preferences API calls are made.
  const preferencesProps = useMemo(() => ({
    accountId,
    key: "agent-chat",
    type: "ai-teammate",
  }), [accountId])

  return <PreferenceContext.Provider value={preferencesProps}>
    <AiTeammateProvider managedAgent persistPreferences={false}>
      <ThreadsProvider persistPreferences={false}>
        <AiTeammateAnalyticsProvider>
          <MessagesProvider>
            <div className="agent-chat-page">
              <ChatWorkspace />
            </div>
          </MessagesProvider>
        </AiTeammateAnalyticsProvider>
      </ThreadsProvider>
    </AiTeammateProvider>
  </PreferenceContext.Provider>
}
